<template>
    <div style="width:100%" class="mb-4">

        <v-card class="mx-auto" width="100%">
            <v-card-text>
                <div class="text-h5">PagerDuty</div>
            </v-card-text>

            <v-row>
                <v-col cols="12" md="6" lg="6">
                    <div class="pa-4">

                        <v-list-item two-line>
                            <v-list-item-content>
                                <v-list-item-title>PD Number</v-list-item-title>
                                <v-list-item-subtitle>{{data.pd}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item two-line>
                            <v-list-item-content>
                                <v-list-item-title>Logged</v-list-item-title>
                                <v-list-item-subtitle>{{data.logged | DateTime}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item two-line>
                            <v-list-item-content>
                                <v-list-item-title>Issue</v-list-item-title>
                                <v-list-item-subtitle>{{data.issue}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item two-line>
                            <v-list-item-content>
                                <v-list-item-title>Root Cause</v-list-item-title>
                                <v-list-item-subtitle>{{data.rootCause}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item two-line>
                            <v-list-item-content>
                                <v-list-item-title>Description</v-list-item-title>
                                <v-list-item-subtitle>{{data.description}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item two-line>
                            <v-list-item-content>
                                <v-list-item-title>Team</v-list-item-title>
                                <v-list-item-subtitle>{{data.productTeam}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item two-line>
                            <v-list-item-content>
                                <v-list-item-title>Assigned Group</v-list-item-title>
                                <v-list-item-subtitle>{{data.remedyAssignedgroup}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                    </div>

                </v-col>
                <v-col cols="12" md="6" lg="6">
                    <div class="pa-4">

                        <v-list-item two-line>
                            <v-list-item-content>
                                <v-list-item-title>Service Name</v-list-item-title>
                                <v-list-item-subtitle>{{data.internalServicename}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item two-line>
                            <v-list-item-content>
                                <v-list-item-title>Product</v-list-item-title>
                                <v-list-item-subtitle>{{data.productName}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item two-line>
                            <v-list-item-content>
                                <v-list-item-title>Channel</v-list-item-title>
                                <v-list-item-subtitle>{{data.remedyChannel}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item two-line>
                            <v-list-item-content>
                                <v-list-item-title>Team</v-list-item-title>
                                <v-list-item-subtitle>{{data.pagerdutyTeam}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item two-line>
                            <v-list-item-content>
                                <v-list-item-title>Source</v-list-item-title>
                                <v-list-item-subtitle>{{data.alertSource}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item two-line>
                            <v-list-item-content>
                                <v-list-item-title>Status</v-list-item-title>
                                <v-list-item-subtitle>{{data.statushubStatus}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item two-line>
                            <v-list-item-content>
                                <v-list-item-title>Resolved by</v-list-item-title>
                                <v-list-item-subtitle>{{data.pagerdutyResolvedMethod}} ({{data.pagerdutyTeam}})</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item two-line>
                            <v-list-item-content>
                                <v-list-item-title>Escalation policy</v-list-item-title>
                                <v-list-item-subtitle>{{data.pagerdutyEscalationPolicy}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </div>
                </v-col>
            </v-row>

            <div class="pa-4">
                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Log entries</v-list-item-title>
                        <v-list-item-subtitle v-html="data.pagerdutyLogEntries"></v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Full Detail</v-list-item-title>
                        <v-list-item-subtitle v-html="data.pagerdutyDescription"></v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <!--<v-card-actions>
                    <v-btn text
                           color="accent"
                           @click="onOpenPagerDutyUrl">
                        Pagerduty url: {{data.pagerdutyHtmlUrl }}
                    </v-btn>
                </v-card-actions>-->

            </div>
        </v-card>
    </div>
</template>
<script>
    export default {
        name: 'PostSev',
        data: function () {
            return {
                headers: [
                    { text: 'Incident', value: 'incident' },
                    { text: 'Date', value: 'logged' },
                    { text: 'Customer Perspective', value: 'customerPerspective' },
                    { text: 'Root Cause', value: 'rootCause' },
                    { text: 'Affected Operator', value: 'affectedOperator' },
                    { text: 'Assigned Team', value: 'assignedTeam' },
                    { text: 'Bets', value: 'bets' },
                    { text: 'Registration', value: 'reg' },
                    { text: 'Login', value: 'login' },
                    { text: 'Banking', value: 'banking' },
                    { text: 'Other', value: 'other' },
                    { text: 'Other List', value: 'otherImpactList' },
                    { text: 'Comment', value: 'comment' },
                    { text: 'Assignee', value: 'assignee' },
                    { text: 'Sign Off', value: 'signOff' },
                    { text: 'Updater', value: 'updater' },
                ],
            }
        },
        props: {
            data: {
                default: () => { },
                type: Object
            },
            pieData: {
                default: () => [],
                type: Array
            },
        },
        computed: {
            affectedOperatorArray() {
                if (!this.data.affectedOperator) return [];
                return this.data.affectedOperator.replace("[", "").replace("]", "").replace(/"/g, "").split(',').filter(operator => operator !== "");
            }
        },
        methods: {
            async onOpenPagerDutyUrl() {
                window.open(this.data.pagerdutyHtmlUrl);
            }
        }
    }
</script>
